var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.cssProps)},[_c('toolbar',{attrs:{"isMainView":_vm.isMainView,"isToolEditor":_vm.isToolEditor}}),_c('v-content',{style:(_vm.isSecondToolbarVisible
        ? 'padding: 112px 0px 0px'
        : 'padding: 64px 0px 0px')},[_c('v-container',{staticStyle:{"align-items":"start !important"},attrs:{"fill-height":"","fluid":""}},[_c('router-view')],1)],1),_c('toasts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }